import React from "react";
import { IBannerId } from "../../Banner.props";
import EditBanner from "./EditBanner";

const EditBannerIndex: React.FC<IBannerId> = ({ bannerId }) => {
  return <EditBanner bannerId={bannerId} />;
};

export default EditBannerIndex;
